import { combineEpics } from "redux-observable";
import { push } from "react-router-redux";
import { candidate, insider } from "routes/paths";
import * as fbPixel from "core/integrations/fb_pixel";
import * as dataLayer from "core/integrations/gtm";
import * as linkedinPixel from "core/integrations/linkedin-pixel";
import * as api from "./api";

export default combineEpics(
  action$ =>
    action$
      .ofType(api.submitInsiderFeedback.types.success)
      .mapTo(push(candidate.candidateFeedbackSuccess)),
  action$ =>
    action$
      .ofType(api.submitCandidateFeedback.types.success)
      .mapTo(push(insider.insiderFeedbackSuccess)),
  action$ =>
    action$
      .ofType(api.submitInsiderFeedback.types.success)
      .do(() => {
        fbPixel.fbq("trackCustom", "InsiderReviewed");
        dataLayer.push({
          event: "insiderReviewed"
        });
        linkedinPixel.track(292569);
      })
      .filter(() => false),
  action$ =>
    action$
      .ofType(api.submitCandidateFeedback)
      .do(() => {
        fbPixel.fbq("trackCustom", "CandidateReviewed");
        dataLayer.push({
          event: "candidateReviewed"
        });
        linkedinPixel.track(292577);
      })
      .filter(() => false)
);



// WEBPACK FOOTER //
// ./src/modules/feedback/epic.js